<template>
  <div class="filesList">
    <div class="row file" v-for="file in files[type]" :key="file.id">
      <div class="col-md-1 file-ico">
        <img :src="file.icon" alt="file_ico">
      </div>
      <div class="col-md-11 file-card">
        <strong v-if="!editarray[file.id]" class="file-title" v-html="file.title"></strong>
        <i v-if="$root.user.option.filesmod && !editarray[file.id]" class="far fa-edit mx-1" @click="edit(file.id)"></i>
        <p v-if="!editarray[file.id]" class="file-text" v-html="file.text"></p>
        <div v-if="editarray[file.id]" class="form-group col-10">
          <input type="text" class="form-control" v-model="file.title">
          <textarea class="form-control" v-model="file.text"></textarea>
          <i class="fas fa-check fa-2x" @click="endedit(file.id, 1)"></i>
          <i class="fas fa-times fa-2x mx-2" @click="endedit(file.id, 0)"></i>
        </div>
        <hr>
      </div>
    </div>
    <div class="row">
        <div class="col-12">
            <newfile v-if="$root.user.option.filesmod" />
        </div>
    </div>
  </div>
</template>

<script>
import json from "../../../assets/files.json"
import newfile from "./blocks/newfile"

export default {
  methods: {
    edit: function(id) {
      this.$set(this.editarray, id, 1);
    },
    endedit: function(id, save) {
      this.$set(this.editarray, id, 0);
    }
  },
  props: ["type"],
  data() {
    console.log(this);
    return {
      files: json,
      editarray: []
    };
  },
  components: {
      newfile
  }
};
</script>

